<div class="table-container">
  <div class="table-responsive card-style mb-3">
    <table [id]="handlers.buildElementId('table')" class="table m-0 box-shadow">
      <thead>
        <tr>
          @for (column of columns; track handlers.trackByColumn($index, column); let colIdx = $index) {
            @if (column.selected) {
              <th class="resizable" [class.checkbox]="!column.title">
                <div [class]="!!column.title && column.searchable ? ['justify-content-between'] : column?.class">
                  <p class="d-block" [class.checkbox]="!column.title">
                    @if (column.title) {
                      {{ column.title === "selector" ? "" : column.label || column.title }}
                      @if (column.tooltip && column.title !== "selector") {
                        <app-vficon
                          (click)="column.tooltip ? handlers.handleColumnTooltipClick(column.tooltip) : null"
                          class="ms-1 icon-wrapper clickable column-tooltip-icon"
                          [class.clickable]="!!handlers.extractUrl(column.tooltip || '')"
                          [tooltip]="column?.tooltip"
                          container="body"
                          placement="left"
                          iconPack="source-system-icons"
                          iconName="info-circle"
                          size="16px"
                        ></app-vficon>
                      }
                      @if (
                        !!column.title &&
                        (column.sortable ?? column.searchable) &&
                        (currentPage?.length ?? 0) > 1 &&
                        column.title !== "selector"
                      ) {
                        <span
                          [id]="handlers.buildElementId('sort-button', undefined, colIdx)"
                          (click)="handlers.sortDataByColumn(column, colIdx)"
                          tooltip="Sort data"
                          placement="right"
                          class="clickable px-2 sorting-icon"
                        >
                          @switch (sortOrders[column.title]) {
                            @case (undefined) {
                              <app-vficon iconPack="source-system-icons" iconName="chevron-up"></app-vficon>
                            }
                            @case ("ASC") {
                              <app-vficon iconPack="source-system-icons" iconName="chevron-up"></app-vficon>
                            }
                            @case ("DESC") {
                              <app-vficon iconPack="source-system-icons" iconName="chevron-down"></app-vficon>
                            }
                          }
                        </span>
                      }
                    }
                    @if (showSelectAllCheckbox && column.title === "selector") {
                      <input
                        [id]="handlers.buildElementId('select-all')"
                        aria-label="Select all rows"
                        class="align-top select-all-cb"
                        type="checkbox"
                        (change)="handlers.selectAllRows($event, tableRows)"
                        [checked]="areAllRowsSelected"
                      />
                    }
                  </p>
                </div>
              </th>
            }
          }
        </tr>
      </thead>
      <tbody>
        @for (row of currentPage; track $index; let rowIndex = $index) {
          <tr
            [ngStyle]="{
              background: row[0]?.rowWarning
                ? backgroundColors?.warning
                : row[0]?.rowSuccess
                  ? backgroundColors?.success
                  : row[0]?.rowDanger
                    ? backgroundColors.danger
                    : row[0]?.rowWhite
                      ? backgroundColors.white
                      : backgroundColors.default,
            }"
          >
            @for (column of columns; track handlers.trackByColumn($index, column); let idx = $index) {
              @if (column.selected) {
                <td
                  [class.warning]="row[idx]?.cellWarning"
                  [class.success]="row[idx]?.cellSuccess"
                  [class.danger]="row[idx]?.cellDanger"
                >
                  @if (handlers.isRowInEditMode(rowIndex) && row[idx]?.type === undefined) {
                    <div class="d-flex align-items-center editable-cell h-100 p-2">
                      @if (row[idx]?.inputType === "text") {
                        <input
                          [id]="handlers.buildElementId('text-input', rowIndex, idx)"
                          type="text"
                          class="form-control form-control-sm item-name-field"
                          [class]="row[idx]?.classes"
                          [(ngModel)]="row[idx].value"
                          [ngModelOptions]="{ standalone: true }"
                          [placeholder]="row[idx]?.placeholder || ''"
                          [disabled]="row[idx]?.disabled"
                          (change)="handlers.notifyCellChange($event, row[idx]?.data, column.title, row)"
                        />
                      }
                      @if (row[idx]?.inputType === "multiSelect") {
                        <app-custom-dropdown
                          class="w-100"
                          [label]="''"
                          [placeholder]="
                            row[idx].selected?.length > 0 ? '' : getPlaceholder(row[idx]?.placeholder) || 'Select items'
                          "
                          [tooltip]="getTooltip(row[idx]?.tooltip)"
                          [control]="row[idx].control"
                          [searchControl]="row[idx].searchControl"
                          [data]="row[idx].list"
                          [multiple]="true"
                          [searchable]="true"
                          [isInvalid]="false"
                          [errorMessage]="''"
                          [valueProperty]="'display_name'"
                          [displayProperty]="'display_name'"
                          (valueChange)="handlers.notifyCellChange($event, row[idx]?.data, column.title, row)"
                        />
                      }
                    </div>
                  }
                  @if (
                    !handlers.isRowInEditMode(rowIndex) ||
                    (row[idx]?.inputType !== "text" && row[idx]?.inputType !== "multiSelect") ||
                    row[idx]?.type !== undefined
                  ) {
                    @if (row[idx] === undefined || row[idx]?.type === undefined) {
                      @if (row[idx]?.innerHTML) {
                        <p
                          class="cell-content"
                          [tooltip]="getTooltip(row[idx]?.tooltip)"
                          placement="right"
                          [class]="row[idx]?.classes"
                          [ngStyle]="row[idx]?.styles"
                          [innerHTML]="row[idx]?.innerHTML"
                        ></p>
                      }
                      @if (!row[idx]?.innerHTML) {
                        <p
                          class="cell-content flex-column"
                          [tooltip]="isArray(row[idx]?.value) ? '' : getTooltip(row[idx]?.tooltip)"
                          placement="right"
                          [class]="row[idx]?.classes"
                          [ngStyle]="row[idx]?.styles"
                          [class.align-items-start]="isArray(row[idx]?.value)"
                        >
                          @switch (isArray(row[idx]?.value)) {
                            @case (true) {
                              <span class="array-value-content">
                                {{ row[idx]?.value.join(",") || "--" }}
                              </span>
                              @if (row[idx]?.icons) {
                                <app-vficon
                                  [iconName]="getIconName(row[idx]?.icons)"
                                  iconPack="source-system-icons"
                                ></app-vficon>
                              }
                            }
                            @default {
                              <span class="cell-value-content">
                                <span
                                  class="truncate d-inline-block"
                                  [title]="(row[idx]?.value || '').length > 10 ? row[idx]?.value : ''"
                                  [tooltip]="row[idx]?.value || ''"
                                  >{{ row[idx]?.value || "--" }}</span
                                >
                                @if (
                                  !row[idx]?.icons &&
                                  (row[idx]?.value || 0).substring &&
                                  !emptyValues.includes((row[idx]?.value || "--").trim())
                                ) {
                                  <app-vficon
                                    class="clickable position-relative copy-icon"
                                    tooltip="Click to copy"
                                    size="14px"
                                    (click)="handlers.copyValue(row[idx]?.rawValue ?? row[idx]?.value)"
                                    iconName="copy"
                                    iconPack="source-system-icons"
                                  ></app-vficon>
                                }
                              </span>
                              @if (row[idx]?.icons) {
                                <app-vficon
                                  [iconName]="getIconName(row[idx]?.icons)"
                                  iconPack="source-system-icons"
                                ></app-vficon>
                              }
                            }
                          }
                        </p>
                      }
                    } @else {
                      <app-cell-type-renderer
                        [cell]="row[idx]"
                        [rowIndex]="rowIndex"
                        [colIndex]="idx"
                        [columnTitle]="column.title"
                        [handlers]="handlers"
                        [backgroundColors]="backgroundColors"
                        [emptyValues]="emptyValues"
                        [row]="row"
                        (cellChange)="
                          handlers.notifyCellChange(
                            $event.event,
                            $event.data,
                            $event.column,
                            $event.row,
                            $event.options,
                            $event.action
                          )
                        "
                      ></app-cell-type-renderer>
                      <app-cell-subtype-renderer
                        [cell]="row[idx]"
                        [rowIndex]="rowIndex"
                        [colIndex]="idx"
                        [columnTitle]="column.title"
                        [handlers]="handlers"
                        [row]="row"
                        [weekDays]="weekDays"
                        [daysOfWeek]="daysOfWeek"
                        [exclusionTypes]="exclusionTypes"
                        (cellChange)="
                          handlers.notifyCellChange(
                            $event.event,
                            $event.data,
                            $event.column,
                            $event.row,
                            $event.options,
                            $event.action
                          )
                        "
                      ></app-cell-subtype-renderer>
                    }
                  }
                </td>
              }
            }
          </tr>
        }
        @if (findColumnValueTotal || computeMomTrend) {
          <tr class="grand-total">
            @for (column of columns; track $index; let idx = $index) {
              @if (handlers.columnNotExcluded(column, idx)) {
                <td>
                  @if (column.sum) {
                    <p class="find-sum">
                      {{ idx === 0 ? "Grand Total" : column.sum ? handlers.columnTotal(idx) : "--" }}
                    </p>
                  }

                  @if (column.computeMomTrend) {
                    <p class="find-sum">
                      {{ idx === 0 ? "Grand Total" : column.computeMomTrend ? handlers.columnMomTrend(idx) : "--" }}
                    </p>
                  }
                </td>
              }
            }
          </tr>
        }
        @if (customGrandTotal?.length > 0) {
          <tr class="grand-total">
            @for (column of customGrandTotal; track $index; let i = $index) {
              @if (handlers.columnNotExcluded(column, i)) {
                <td>
                  <p class="find-sum">
                    {{ column?.value }}
                  </p>
                </td>
              }
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
